import React from 'react';
import { css } from 'glamor';
import Popover from '@material-ui/core/Popover';
import * as theme from '../../theme';
import { BayOptionList } from './BayOptionList';
import { TYPE_SCALE, TYPOGRAPHY } from './constants/typography';

/* Change-bay popover (DRI-2874), ported from Nick's preview design and wired to
 * our free-bay list. */
const body = css({ padding: 16, width: 320, maxHeight: 420, overflowY: 'auto' });
const heading = css({
	...TYPE_SCALE.subheading,
	color: theme.gray70,
	marginBottom: 10,
});
const empty = css(TYPOGRAPHY.muted, { marginBottom: 10 });

export const ChangeBayPopover = ({
	anchorEl,
	open,
	onClose,
	bays,
	selectedBayId,
	onSelect,
	title = 'Change bay',
}) => (
	<Popover
		open={open}
		anchorEl={anchorEl}
		onClose={onClose}
		anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
	>
		<div className={body} onClick={(event) => event.stopPropagation()}>
			<div className={heading}>{title}</div>
			{bays.length === 0 ? (
				<div className={empty}>No bay is available for the selected period.</div>
			) : (
				<BayOptionList
					bays={bays}
					selectedBayId={selectedBayId}
					onSelect={onSelect}
				/>
			)}
		</div>
	</Popover>
);
